const unwrapResponse = (response) => response?.body ?? response?.data ?? response;

const getRole = (value) => value?.user_role ?? value?.role ?? null;

export const normalizeLoginResponse = (response, fallbackUsername = '') => {
  const normalized = unwrapResponse(response);

  if (normalized?.challengeName && normalized?.session && normalized?.username) {
    return {
      type: 'challenge',
      challengeName: normalized.challengeName,
      session: normalized.session,
      username: normalized.username,
      message: normalized.message || response?.message || 'Additional authentication is required.',
    };
  }

  if (!normalized?.idToken || !normalized?.refreshToken) {
    throw new Error('The login response did not contain a complete session.');
  }

  return {
    type: 'authenticated',
    session: {
      idToken: normalized.idToken,
      accessToken: normalized.accessToken || null,
      refreshToken: normalized.refreshToken,
      username: normalized.username?.trim() || fallbackUsername.trim() || null,
      source: 'credentials',
      role: getRole(normalized),
    },
  };
};

export const normalizeMfaResponse = (response, fallbackUsername = '') => {
  const normalized = unwrapResponse(response);
  if (!normalized?.idToken || !normalized?.refreshToken) {
    throw new Error('The verification response did not contain a complete session.');
  }

  return {
    idToken: normalized.idToken,
    accessToken: normalized.accessToken || null,
    refreshToken: normalized.refreshToken,
    username: normalized.username?.trim() || fallbackUsername.trim() || null,
    source: 'credentials',
    role: getRole(normalized),
  };
};
